import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import { JSONSchema7 } from 'json-schema';
import * as yup from 'yup';
import ControlState from '../../Shared/controlState';

export default (
  control: ControlState
): {
  [key: string]: yup.AnySchema;
} => {
  const properties = control.schema?.properties as JSONSchema7Properties;
  const labelSchema = properties['label'] as JSONSchema7;
  const requiredSchema = properties['required'] as JSONSchema7;
  const minimumSchema = properties['minimum'] as JSONSchema7;
  const maximumSchema = properties['maximum'] as JSONSchema7;
  const decimalPlacesSchema = properties['decimalPlaces'] as JSONSchema7;

  let controlYupSchema = yup
    .number()
    .transform((_, val) => (val ? Number(val) : null))
    .typeError('Must be a number')
    .nullable(true);

  if (!control.visible) {
    return {
      [control.id]: controlYupSchema
    };
  }

  if (requiredSchema && requiredSchema.default) {
    controlYupSchema = controlYupSchema.required(
      `${labelSchema.default} is required`
    );
  }

  if (minimumSchema) {
    const min = minimumSchema.default as number;
    controlYupSchema = controlYupSchema.min(
      min,
      `${labelSchema.default} must be greater than or equal to ${min}`
    );
  }

  if (maximumSchema) {
    const max = maximumSchema.default as number;
    controlYupSchema = controlYupSchema.max(
      max,
      `${labelSchema.default} must be less than or equal to ${max}`
    );
  }

  if (decimalPlacesSchema) {
    const decimalPlaces = decimalPlacesSchema.default as number;
    controlYupSchema = controlYupSchema.test(
      'maxDigitsAfterDecimal',
      `${labelSchema.default} must have ${decimalPlaces} digits after decimal or less`,
      (number) =>
        String(number).includes('.')
          ? String(number).split('.')[1].length <= decimalPlaces
          : true
    );
  }

  return {
    [control.id]: controlYupSchema
  };
};
